function convertBrand(brand) {
  const query = /&/g;
  return brand.replace(query, "%26").toLowerCase();
}
export {
  convertBrand
};
//# sourceMappingURL=convert-brand.js.map
